import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { FilterService } from '../_services/filter.service';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { User, Location } from '../_models/user';
import { TextFiltersService } from '../_services/text-filters.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  currentUser: User = null;
  filterReq$: Subscription = null;
  documentsReq$: Subscription = null;
  userReq$: Subscription = null;
  currentLocation: Location = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private filterService: FilterService,
    private textFiltersService: TextFiltersService) { }

  ngOnInit() {
    this.textFiltersService.clearStorage();
    this.userReq$ = this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
      if (this.currentUser && this.currentUser.locationRoles && this.currentUser?.selectedLocationIndex?.toString()) {
        this.currentLocation = this.currentUser.locationRoles[this.currentUser.selectedLocationIndex? this.currentUser.selectedLocationIndex : 0 ];
      }
    });
  }

  ngOnDestroy() {
    if (this.filterReq$)
      this.filterReq$.unsubscribe();
    if (this.documentsReq$)
      this.documentsReq$.unsubscribe();
    if (this.userReq$)
      this.userReq$.unsubscribe();
  }

  goTo(route: string) {
    this.router.navigateByUrl(route);
  }

  private defaultDateFormatted() {
    const today = moment();
    return { year: +today.format('YYYY'), month: +today.format('MM'), day: +today.format('DD') };
  }


  search() {
    this.filterService.storeFiltersConfig(this.filterService.filtersConfig.value);
    this.router.navigateByUrl('/searchresults');
  }

  parseDate() {
    const today = moment();
    return { year: +today.format('YYYY'), month: +today.format('MM'), day: +today.format('DD') };
  }
}
